@if (maneuverForm) {
	<div [formGroup]="maneuverForm">
		<!-- @if (isManeuverVisible) {
    <p>Please Select OB's :</p>
    } -->
		<div class="ob-selection-section">
			@if (showExpansion) {
				<mat-accordion [multi]="true" class="ob-selection-accordion">
					@for (OB of OB_LIST; track OB.title; let i = $index) {
						@if (obSections[OB.title]) {
							<mat-expansion-panel
								class="mat-elevation-z0"
								(opened)="panelOpenState = true"
								(closed)="panelOpenState = false"
								[expanded]="hasValue(OB.title)"
							>
								<mat-expansion-panel-header>
									<mat-panel-title>
										<div class="flex w-full flex-row items-center gap-2">
											<div class="size-2 rounded-full" [class.bg-red]="hasValue(OB.title)"></div>
											<span class="title whitespace-nowrap">
												<span class="font-bold">{{ OB.title }}</span>
												<span class="text-lg font-bold">&nbsp;&#183;&nbsp;</span>
												{{ OB.desc }}
											</span>
											<div class="mx-2 flex-1 border-b border-b-black"></div>
										</div>
									</mat-panel-title>
								</mat-expansion-panel-header>

								<!-- Single dynamic binding: no hardcoded category names -->
								@if (obSections[OB.title]; as group) {
									<div class="pl-5 pr-5">
										<app-observation-card-v2
											[obFormGroup]="group"
											[OB]="OB"
											[singleCount]="false"
											[canUndoByKey]="canUndoByKey"
											(emitOBContainerValue)="onCheckBoxClick($event)"
											[enableNA]="true"
										>
										</app-observation-card-v2>
									</div>
								}

								<!-- optional fallback if the form lacks a group for a title -->
								@if (!obSections[OB.title]) {
									<div class="p-4 text-sm text-red-600">No form group found for "{{ OB.title }}".</div>
								}
							</mat-expansion-panel>
						}
					}
				</mat-accordion>
			} @else {
				@for (OB of OB_LIST; track OB.title; let i = $index) {
					@let cg = maneuverForm.get(OB.title);
					@if (cg) {
						@if (obSections[OB.title]; as group) {
							<div class="pl-5 pr-5">
								<app-observation-card-v2
									[obFormGroup]="group"
									[OB]="OB"
									[singleCount]="false"
									[canUndoByKey]="canUndoByKey"
									(emitOBContainerValue)="onCheckBoxClick($event)"
									[enableNA]="true"
								>
								</app-observation-card-v2>
							</div>
						}
					}
				}
			}

			@if (isSafetyOutcomeVisible) {
				<div class="my-8">
					<app-cbta-checkbox-rating
						name="safetyOutcome"
						[label]="isTS1 ? 'TEM Safety Outcome' : 'TEM Training Effectiveness'"
						(ratingChange)="onRatingChange($event)"
						[rating]="5"
						[currentValue]="$safeNavigationMigration(safetyOutcome?.value)"
						[isDisabled]="(disableSafetyOutcome$ | async) ?? false"
					>
					</app-cbta-checkbox-rating>

					@if (showTemError) {
						<mat-error class="mt-2">
							{{ sharedService.getErrorMessage(safetyOutcome!) || temErrorText }}
						</mat-error>
					}
					<input type="hidden" class="hidden" formControlName="safetyOutcome" [value]="safetyOutcome?.value ?? -2" />
				</div>
			}

			@if (isSafetyOutcomeVisible && (isTS1 || isCabinCrewForm)) {
				<div class="m-4 flex flex-row justify-between">
					<div class="grid grid-cols-3 gap-4">
						<button
							[disabled]="(disableSafetyOutcome$ | async) ?? false"
							mat-stroked-button
							class="border border-black text-black"
							(click)="repeatConfirmModal()"
						>
							Repeat
						</button>
					</div>
				</div>
			}
		</div>
	</div>
}
